import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const PINNED_ITEMS_KEY = 'v8.pinnedItems';
const MAX_PINNED = 8;

@Injectable({
	providedIn: 'root'
})
export class PinnedMenuService {
	private pinnedItems$ = new BehaviorSubject<string[]>(this.loadPinnedItems());

	get pinnedItems(): string[] {
		return this.pinnedItems$.getValue();
	}

	private loadPinnedItems(): string[] {
		try {
			const stored = localStorage.getItem(PINNED_ITEMS_KEY);
			return stored ? JSON.parse(stored) : [];
		} catch {
			return [];
		}
	}

	private savePinnedItems(items: string[]): void {
		try {
			localStorage.setItem(PINNED_ITEMS_KEY, JSON.stringify(items));
		} catch {
			// ignore
		}
	}

	togglePin(itemId: string): void {
		if (itemId === 'logout') return;
		const items = this.pinnedItems$.getValue();
		const index = items.indexOf(itemId);
		if (index > -1) {
			const updated = items.filter(id => id !== itemId);
			this.savePinnedItems(updated);
			this.pinnedItems$.next(updated);
			return;
		}
		if (items.length >= MAX_PINNED) return;
		const updated = [...items, itemId];
		this.savePinnedItems(updated);
		this.pinnedItems$.next(updated);
	}

	subscribe(fn: (ids: string[]) => void): { unsubscribe: () => void } {
		const sub = this.pinnedItems$.subscribe(fn);
		return { unsubscribe: () => sub.unsubscribe() };
	}

	clearPinned(): void {
		this.pinnedItems$.next([]);
		this.savePinnedItems([]);
	}
}
